import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicyAileesa() {
  
  const PRIVACY_POLICY_CONTENT = `Effective Date: 1 April 2026

This Privacy Policy describes how Aileesa ("we", "our", or "us") collects, uses, and safeguards your information when you use our mobile application. By using the app, you agree to the practices described below.

1. INFORMATION WE COLLECT

We may collect the following:

  • Phone number — used solely for authentication via OTP.
  • Language preference — stored locally on your device.
  • Reading progress — chapter and kural completion data, streaks, and bookmarks, stored on our secure servers if you are signed in.
  • Device information — OS version, device model, and anonymised crash logs for stability improvements.

We do not collect names, email addresses, or any financial data directly. Payment is processed by the App Store / Google Play and governed by their respective privacy policies.

2. HOW WE USE YOUR INFORMATION

  • To authenticate you securely via OTP.
  • To sync your bookmarks and reading progress across devices.
  • To improve app performance using anonymised crash reports.
  • To deliver daily Kural notifications if you opt in.

We do not sell, rent, or share your personal data with third parties for marketing purposes.

3. DATA STORAGE AND SECURITY

Your data is stored on servers located in India, compliant with the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2023 (DPDPA). We use industry-standard encryption (TLS) for data in transit and at rest.

4. YOUR RIGHTS

Under the DPDPA 2023, you have the right to:
  • Access the personal data we hold about you.
  • Correct inaccurate data.
  • Request erasure of your personal data.
  • Withdraw consent at any time.

To exercise these rights, write to us at privacy@aileesa.app.

5. COOKIES AND THIRD-PARTY SERVICES

The app uses Supabase for authentication and data storage. Their privacy policy applies to data processed by their infrastructure.

6. CHILDREN'S PRIVACY

This app is not directed at children under the age of 13. We do not knowingly collect data from minors.

7. CHANGES TO THIS POLICY

We may update this policy periodically. Continued use of the app after changes constitutes acceptance of the revised policy.

8. CONTACT

For privacy concerns, contact us at:
  privacy@aileesa.app
  Aileesa, Tamil Nadu, India`;


  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: April 01, 2026</p>

        <pre className="privacy-policy-text">{PRIVACY_POLICY_CONTENT}</pre>

        <div className="acknowledgment">
          <p>
            By using our services, you acknowledge that you have read, understood, and agree to be bound 
            by this Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyAileesa;
